 $(function(){
   tabControl();

//     var resizeTimer;
//     $(window).on('resize', function(e) {
//       clearTimeout(resizeTimer);
//       resizeTimer = setTimeout(function() {
//         // this stops the accordion working - unclear why
//         tabControl();
//       }, 250);
//     });
   // THIS IS MOBILE
   function tabControl() {
    var tabs = $('.tabbed-content').find('.tabs');
    if(tabs.is(':hidden')) {
	$('[class*=dryrobe-dog] #tab-benefits').addClass('hide');
    $('.item').on('click', function() {
    $(this).toggleClass('active');
    $(this).removeClass('active-load');
    var currentID = $(this).attr('id'),
        container = $(this).parents('.tabbed-content'),
        sitems = container.find('.item');
        container.find('.tabs li').removeClass('active').removeClass('active-load');
        container.find('.tabs [data-href$="#'+ currentID +'"]').closest('li').toggleClass('active');
      }).children().click(function(e) {
        return false;
      });
    };
//     THIS IS DESKTOP
      var tabs = $('.tabbed-content').find('.tabs');
      if(tabs.is(':visible')) {
        tabs.find('li').on('click', function(event) {
          event.preventDefault();
          var target = $(this).attr('data-href'),
              tabs = $(this).parents('.tabs'),
              buttons = tabs.find('li'),
              item = tabs.parents('.tabbed-content').find('.item');
              // alert(target);
          buttons.removeClass('active').removeClass('active-load');
          item.removeClass('active').removeClass('active-load');
          $(this).closest('li').addClass('active-load');
          $(target).addClass('active-load');
        });
      }
    }
});